<div [formGroup]="detailsForm" class="station-assignment-details no-field-space">

  <sc-flex >

    <mat-form-field class="input" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.position-x"></sc-dictionary-label>
      </mat-label>
      <input matInput matInputInteger name="posX" formControlName="posX"
        [required]="true" type="NUMBER">
    </mat-form-field>

    <sc-content-spacer vertical></sc-content-spacer>

    <mat-form-field class="input" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.position-y"></sc-dictionary-label>
      </mat-label>
      <input matInput matInputInteger name="posY" formControlName="posY"
        [required]="true" type="NUMBER">
    </mat-form-field>

  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex centered>
    <sc-delete-action-button (click)="removeStationAssignment()" large></sc-delete-action-button>
  </sc-flex>
</div>
